import { useState, useRef, useEffect } from 'react';

export const AudioRecorder = (onRecordingComplete) => {
  const [isRecording, setIsRecording] = useState(false);
  const [audioBlob, setAudioBlob] = useState(null);
  const [error, setError] = useState(null);

  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const onRecordingCompleteRef = useRef(onRecordingComplete);

  // Keep the callback ref updated
  useEffect(() => {
    onRecordingCompleteRef.current = onRecordingComplete;
  }, [onRecordingComplete]);

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(stream);
      audioChunksRef.current = [];

      mediaRecorderRef.current.ondataavailable = (event) => {
        audioChunksRef.current.push(event.data);
      };

      mediaRecorderRef.current.onstop = () => {
        const audioBlobResult = new Blob(audioChunksRef.current, { type: 'audio/wav' });
        setAudioBlob(audioBlobResult);
        
        // Call the callback if provided
        if (onRecordingCompleteRef.current) {
          onRecordingCompleteRef.current(audioBlobResult);
        }
      };

      mediaRecorderRef.current.start();
      setIsRecording(true);

    } catch (err) {
      console.error("Erro ao acessar o microfone:", err);
      setError("Não foi possível acessar o microfone. Verifique as permissões.");
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'recording') {
      mediaRecorderRef.current.stop();
      setIsRecording(false);
    }
  };
  // Função para limpar o audioBlob
  const clearAudioBlob = () => {
    setAudioBlob(null);
  };
  // Limpa o stream quando o componente é desmontado
  useEffect(() => {
    return () => {
      if (mediaRecorderRef.current) {
        mediaRecorderRef.current.stream.getTracks().forEach(track => track.stop());
      }
    };
  }, []);

  return { isRecording, audioBlob, error, startRecording, stopRecording, clearAudioBlob };
};